import { Component, OnInit } from '@angular/core';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';
import { ContactsService } from 'src/app/services/client-services/contacts.service';
import { LeadService } from 'src/app/services/client-services/leads.service';
import { DealsService } from 'src/app/services/deals.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { CompaniesService } from 'src/app/services/client-services/companies.service';
import { forkJoin } from 'rxjs';
import DateUtils from 'src/app/utils/date';
import { OrganizationService } from 'src/app/services/organizationservice';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';

@Component({
  selector: 'app-new-card-reports',
  templateUrl: './new-card-reports.component.html',
  styleUrls: ['./new-card-reports.component.css']
})
export class NewCardReportsComponent implements OnInit {
  showCard = false;
  dashData: { deals: number; dealWon: number; contacts: number; companys: number; leads: number; invoices: number }
  dateUtil = new DateUtils();
  constructor(
    private reportSetSrv: ReportSettingsService,
    private organisation_service: OrganizationService,
    private conatactSrv: ContactsService,
    private performRepSrv: PerformanceReportService,
    private leadSrv: LeadService,
    private dealSrv: DealsService,
    private invoiceSrv: InvoiceService,
    private companySrv: CompaniesService,
  ) { }

  ngOnInit() {
    this.getReportConfig();
  }

  getReportConfig() {
    this.showCard = false
    let config = { newDealDays: 0, newDealWonDays: 0, newLeadDays: 0, newContactDays: 0, newCompanyDays: 0, newInvoiceDays: 0 };
    const getRepConfig = this.reportSetSrv.getReportConfig();
    const getActiveSaleper = this.organisation_service.getUsersInOrganization(5);
    forkJoin([getRepConfig, getActiveSaleper]).subscribe(([res, salespersonsRes]) => {
      const salespersons = this.transformSalesper(salespersonsRes);
      config = res || config;
      const { newDealWonDays, newContactDays, newDealDays, newLeadDays, newCompanyDays, newInvoiceDays } = config;
      const getContacts = this.conatactSrv.getContactsByFilter(this.getQuery(newContactDays))
      const getCompany = this.companySrv.getCompaniesByFilter(this.getQuery(newCompanyDays))
      const getLeads = this.leadSrv.filterLead(this.getQuery(newLeadDays));
      const getInvoices = this.invoiceSrv.getInvoiceByFilter(this.getQuery(newInvoiceDays))
      const getOpenNewDeal = this.dealSrv.getAllDealsStatusStatistics(this.getDealQuery(newDealDays, 0))
      const getWonNewDeal = this.dealSrv.getDealsStatusStatistics(this.getDealQuery(newDealWonDays, 2))
      forkJoin([getContacts, getCompany, getLeads, getInvoices, getOpenNewDeal, getWonNewDeal]).subscribe(
        ([{ payload: contacts }, { payload: companys }, { payload: leads }, { payload: invoices }, openDeals, wonDeals]) => {
          this.performRepSrv.new_cards_reports.next({ leads, salespersons, contacts, companys, invoices })
          const openDeal = openDeals.reduce((prev, curr) => prev + curr.size, 0)
          const wonDeal = wonDeals.reduce((prev, curr) => prev + curr.size, 0);
          this.dashData = {
            contacts: contacts.records.length,
            companys: companys.records.length,
            leads: leads.records.length,
            deals: openDeal,
            dealWon: wonDeal,
            invoices: invoices.length
          }
          this.showCard = true;
        })
    })
  }
  
  getQuery = (value) => {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const endDate = getEndTimeStp(new Date())
    return `range=${(JSON.stringify({ createdAt: { from: getTsByNum(value), to: endDate } }))}`
  }

  getDealQuery(value, status, filter = 'SALESPERSON') {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const query = {
      endDate: getEndTimeStp(new Date()),
      startDate: getTsByNum(value),
      status,
      filter
    }
    return query;
  }
  transformSalesper(salespersons: any[]) {
    const result = {};
    salespersons.forEach(sp => result[sp.id] = sp);
    return result;
  }

}
